import { render, staticRenderFns } from "./M2hEvents.vue?vue&type=template&id=1ce30044&scoped=true&"
import script from "./M2hEvents.vue?vue&type=script&lang=js&"
export * from "./M2hEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce30044",
  null
  
)

export default component.exports